module.exports = __webpack_public_path__ + "img/mobile-gear-1.4813e9cf.png";